'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
export type * from "/tmp/build-191/node_modules/@eliadmin/core/src/components/auth/register-form.tsx";
export { registerSchema } from "@eliadmin/core/src/components/auth/register-schema";
type Props = NonNullable<ComponentProps<typeof import("/tmp/build-191/node_modules/@eliadmin/core/src/components/auth/register-form.tsx").RegisterForm>>;
const Deferred = lazy(() => import("@eliadmin/module-original/registerForm").then(m => ({ default: m.RegisterForm })));
export function RegisterForm(props: Props) {  return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }

